import React, { Fragment } from "react";
import Sticky from "react-stickynode";
import { ThemeProvider } from "styled-components";
import { interiorTheme } from "common/theme/interior";
import { DrawerProvider } from "common/contexts/DrawerContext";
import Navbar from "containers/Interior/Navbar";
import Footer from "containers/Interior/Footer";
import Heading from "common/components/Heading";
import { ResetCSS } from "common/assets/css/style";
import {
  GlobalStyle,
  InteriorWrapper,
  ContentWrapper,
  BodyWrapper,
} from "containers/Interior/interior.style";
import SEO from "components/seo";

export default () => {
  return (
    <ThemeProvider theme={interiorTheme}>
      <Fragment>
        <SEO title="Parcel + Post Expo Amsterdam 2019" />
        <ResetCSS />
        <GlobalStyle />

        {/* Start writing your markup from here. */}
        <InteriorWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <ContentWrapper>
            <BodyWrapper>
              <a href="/newsroom" style={{ color: "#00A5C0" }}>
                <Heading as="h5" content="NEWSROOM" />
              </a>
              <Heading
                as="h1"
                content="Direct4me, start-up finalist at Parcel + Post Expo Amsterdam 2019"
              />

              <p>
                <b>
                  Direct4me visited Parcel + Post Expo Amsterdam 2019 and
                  showcased last-mile solution.
                </b>
              </p>

              <p>
                PARCEL+POST EXPO is the leading global event for the world’s
                postal, parcel and express business. With more than 3,000
                attendees from more than 100 countries, PARCEL+POST EXPO is the
                global meeting place for the industry. The event provides the
                most significant opportunities for postal operators, couriers,
                e-fulfilment companies, cross-border shippers and delivery
                companies to discuss current issues and build business
                relationships on a global scale. With 160 international
                exhibitors, it provides an excellent opportunity to learn
                first-hand about the latest innovations and technologies driving
                this industry - from industry-leading partners to brand-new
                start-ups. At the conference, experts debate and discuss the key
                issues and future of the global postal and parcel delivery
                industry. This year, topics covered included e-commerce and
                last-mile delivery, logistics, digital disruption, strategic
                directions, autonomous futures and expanding financial services,
                to name a few. The Universal Postal Union conference sessions
                are always a highlight of PARCEL+POST EXPO, and this year there
                are special sessions discussing the future strategic direction
                of the postal industry.
              </p>

              <p>
                <b>
                  Not only was the Direct4me solution presented at the
                  conference, but as a part of the Innovation & Start-up Day, we
                  were selected as a Parcel & Post Expo Amsterdam 2019 start-up
                  finalist.
                </b>
              </p>
              <p>
                At the conference we showcased our top-notch solution for last
                mile delivery that eliminates the current problems of delivering
                and receiving parcels - one of the main benefits is that it
                enables the parcel to be delivered even if the recipient is not
                at home.
              </p>
              <p>
                With the solution, we are pushing the boundaries of sending and
                receiving parcels and making the process easier for everyone
                involved:
              </p>
              <p>
                • recipients don’t need to be at home to receive the package,
              </p>
              <p>• courier services can deliver the package at any time,</p>
              <p>
                • online shops can use an innovative way of sending packages,
                which can be a big advantage over the competition.
              </p>
              
            </BodyWrapper>
          </ContentWrapper>
          <Footer />
        </InteriorWrapper>
        {/* End of markup section. */}
      </Fragment>
    </ThemeProvider>
  );
};
